﻿'use strict';

angular.module('ntmApp').directive('onOutsideElementClick', [
  function () {
      return {
          restrict: 'A',
          link: function (scope, element, attrs) {

              var container = $('#eSiriusMainId');

              var onClick = function (e) {

                  if (e.target && !$(element).has(e.target).length) {
                      scope.$apply(function () {
                          scope.$eval(attrs.onOutsideElementClick);
                      });
                  }
              };

              container.on('click', onClick);

              scope.$on('$destroy', function () {
                  container.off('click', onClick);
              });
          }
      };
  }
]);